<!-- Footer layout: brand + contact, navigation columns, and payment/legal meta -->
<footer class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer__brand">
      <a class="navbar-brand" href="/">
        <img src="https://static.truckit.net/t4b/logos/logo-light.svg" alt="Truckit.net logo">
      </a>
      <div class="app-footer__contact">
        <div class="app-footer__phone">
          <a href="tel:1300 859 850">          <i class="bi bi-telephone me-2"></i>
            1300 859 850</a>
        </div>
      <div class="app-footer__hours text-muted" style="color: rgba(255, 255, 255, .7) !important; font-size: 1rem;">
        <div>Mon-Thu 8AM to 5PM</div>
        <div>Fri 8AM-4:30PM</div>
        <div>QLD TIME</div>
      </div>
    </div>
      <div class="app-footer__social">
        <ng-container *ngIf="socialLinks.length; else defaultSocialLinks">
          <a *ngFor="let social of socialLinks; trackBy: trackSocial"
             [href]="social.url"
             [attr.aria-label]="social.label"
             [attr.title]="social.label"
             target="_blank"
             class="app-footer__social-link">
            <i [ngClass]="social.icon || 'fa fa-link-45deg'" aria-hidden="true"></i>
          </a>
        </ng-container>
        <ng-template #defaultSocialLinks>
          <a href="https://www.facebook.com/TruckItNetwork/" aria-label="Facebook" title="Facebook" target="_blank" rel="noopener" class="app-footer__social-link">
            <i class="fa fa-facebook" aria-hidden="true"></i>
          </a>
          <a href="https://www.linkedin.com/company/3292927" aria-label="LinkedIn" title="LinkedIn" target="_blank" rel="noopener" class="app-footer__social-link">
            <i class="fa fa-linkedin" aria-hidden="true"></i>
          </a>
          <a href="/news" aria-label="Blog" title="News" class="app-footer__social-link">
            <i class="fa fa-newspaper-o" aria-hidden="true"></i>
          </a>
        </ng-template>
      </div>
    </div>

    <div class="app-footer__nav" *ngIf="sections.length">
      <div class="app-footer__column" *ngFor="let section of sections; trackBy: trackSection">
        <h6>{{section.title}}</h6>
        <a *ngFor="let link of section.links; trackBy: trackLink"
           [href]="link.url"
           [attr.target]="link.target || (link.is_external ? '_blank' : null)"
           [attr.rel]="link.is_external ? 'noopener noreferrer' : null">
          {{link.label}}
        </a>
      </div>
    </div>

    <div class="app-footer__meta">
      <div class="app-footer__payments">
        <img src="assets/payments/payid.png" alt="PayID">
        <img src="assets/payments/mastercard.png" alt="Mastercard">
        <img src="assets/payments/visa.png" alt="Visa">
      </div>
      <div class="app-footer__legal text-center">
        COPYRIGHT <i class="bi bi-c-circle"></i> {{currentYear}} TRUCKIT.NET PTY LTD - ABN 60 627 942 027
      </div>
    </div>
  </div>
</footer>
